import React from 'react';
import PropTypes from "prop-types";

import {Button} from 'reactstrap';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import FFLTextField from "components/Elements/FFLTextField";
import UniversalModalOverride from "components/UniversalModalOverride";
import {confirmAlert} from "react-confirm-alert";


export default class TransactionDealer extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		locations: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		afterDealerSave: PropTypes.func.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			id: null,
			binary_id: null,
			object: null,
			dealerModalOpen: false,
			showUpdatedDealer: false,
			toggleDealerModal: false
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if( prevProps.object.dealers !== this.props.object.dealers ) {
			this.setState({showUpdatedDealer: true});
		}

		if( this.props.toggleDealerModal !== prevProps.toggleDealerModal ) {
			this.setState({
				toggleDealerModal: !this.state.toggleDealerModal,
				id: this.props.dealerId,
				binary_id: this.props.dealerBinaryId,
				object: this.props.dealerObject
			});
		}
	}

	handleToggleDealerModal = () => {
		this.setState({toggleDealerModal: !this.state.toggleDealerModal});
	}

	handleAddDealerClick = () => {
		this.setState({
			id: null,
			binary_id: null,
			object: null
		});

		this.handleToggleDealerModal();
	}

	handleEditDealerClick = () => {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;

		this.setState({
			id: object.dealer,
			binary_id: object.dealer_binary_id,
			object: object.dealers,
		});

		this.handleToggleDealerModal();
	}

	render() {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;
		let {properties, shouldLoad, onSelectUpdate, onTextUpdate, afterDealerSave} = this.props;
		let {toggleDealerModal} = this.state;

		return (
			<div>
				<div className={'form-group'}>
					<div className="row">
						<div className="col-3">
							<span className="input-label">Dealer</span>
							<UniversalModalOverride
								locations={this.props.locations}
								states={this.props.states}
								history={this.props.history}
								id={this.state.id}
								binary_id={this.state.binary_id}
								name={"Dealer"}
								object={Objects.Dealer}
								objectProps={{
									object: this.state.object,
									dealerObject: this.props.dealerObject,
									linkTriggered: this.props.linkTriggered
								}}
								showModal={toggleDealerModal}
								handleToggle={this.handleToggleDealerModal}
								afterSave={afterDealerSave}

							/>
						</div>
						<div className="col-9 d-flex">
							<Button
								data-id={'add-dealer'}
								onClick={this.handleAddDealerClick}
								className={"select-add"}
								size={"sm"} outline color="primary"
							>
								<i className={"fa fa-plus"}/>
							</Button>
							{object.dealer ?
								<Button
									data-id="edit-dealer"
									onClick={this.handleEditDealerClick}
									className="select-add"
									size="sm"
									outline color="green-meadow"
								>
									<i className="fa fa-pencil"/>
								</Button>
								: null}
							<div className={'flex-grow-1'}>
								<Framework.Elements.Select
									shouldLoad={shouldLoad}
									property={properties.dealer}
									value={object.dealer}
									binary_id={object.dealer_binary_id}
									error={object.dealer_error}
									object={object.dealers}
									update={onSelectUpdate}
									text={'name_display|name_company'} // Company is License Name
									textHelper={'name_trade/ffl'} //
									nullable={true}
									sort={'name_display|name_company'}
								/>
							</div>
						</div>
					</div>
				</div>
				<p style={{
					color: "gray",
					padding: "0 4px",
					marginBottom: "19px",
					fontSize: "11px",
					lineHeight: '12px'
				}}>
					The dealer name and FFL are stored with the transaction to
					preserve past Bound Book records in the event the dealer's name
					or FFL number changes.
				</p>
				<div className="form-group">
					<Framework.Elements.TextField
						label={"Dealer Name"}
						property={properties.dealer_name_company}
						value={object.dealer_name_company}
						error={object.dealer_name_company_error}
						update={onTextUpdate}
						disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
					/>
				</div>
				<div className="form-group">
					<FFLTextField
						label={"Dealer FFL"}
						property={!this.state.showUpdatedDealer ? (properties.old_dealer_ffl ?? properties.dealer_ffl) : properties.dealer_ffl}
						value={!this.state.showUpdatedDealer ? (object.old_dealer_ffl ?? object.dealer_ffl) : object.dealer_ffl}
						error={!this.state.showUpdatedDealer ? (object.old_dealer_ffl_error ?? object.dealer_ffl_error) : object.dealer_ffl_error}
						dealer={object.dealers}
						update={this.handleFFLTextFieldPropertyUpdate}
						disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
					/>
				</div>
			</div>
		);
	}
}

